import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/overview_tours/')({
  beforeLoad: () => ({ documentTitle: { main: 'menu.rideBook' } }),
  // Index route - the list is rendered by the parent layout
  // This route exists just to match /bluecoins/ (with trailing slash)
  component: () => null,
});
